const breakpointXl = window.matchMedia('(min-width: 1440px)');
const toggleMegaMenuItems  = document.querySelectorAll('[data-mega-menu]');
const megaMenuDelay        = 200;
let megaMenuTimer;


/**
 * Disable click on .menu-item--toggle-mega-menu anchor
 */
/*toggleMegaMenuItems.forEach(item => {
	const link = item.querySelector(':scope > a');

	if (!link)
	{
		return;
	}

	link.addEventListener('click', function (e) {
		e.preventDefault();
	});
});*/


/**
 * Open the menu when over toggleMegaMenuItem
 */
if (matchMedia('(any-hover: hover)').matches)
{
	toggleMegaMenuItems.forEach(function (el) {
		['mouseenter', 'focusin'].forEach(function (event) {
			el.addEventListener(event, function () {
				if (breakpointXl.matches)
				{
					let menuToOpen = el.dataset.megaMenu;

					openMegaMenu('.' + menuToOpen, el);
				}
			});
		});

		['mouseleave'].forEach(function (event) {
			el.addEventListener(event, function () {
				if (breakpointXl.matches)
				{
					closeMegaMenu();
				}
			});
		});
	});
}


/**
 * Close the menu when leaving the menu, clear timeout when entering the menu
 */
if (matchMedia('(any-hover: hover)').matches)
{
	document.addEventListener('mouseover', function (e) {
		const megaMenu = e.target.closest('.mega-menu');

		if (!megaMenu)
		{
			return;
		}

		// Prevent firing when moving between children
		if (megaMenu.contains(e.relatedTarget))
		{
			return;
		}

		clearTimeout(megaMenuTimer);
	});

	document.addEventListener('mouseout', function (e) {
		const megaMenu = e.target.closest('.mega-menu');

		if (!megaMenu)
		{
			return;
		}

		// Prevent firing when moving between children
		if (megaMenu.contains(e.relatedTarget))
		{
			return;
		}

		if (breakpointXl.matches)
		{
			closeMegaMenu();
		}
	});
}


/**
 * Open the menu
 */
function openMegaMenu(menuToOpen, menuItemActive) {
	clearTimeout(megaMenuTimer);

	if (breakpointXl.matches)
	{
		closeMegaMenu();
	}

	// after hovering for megaMenuDelay, open the menu
	megaMenuTimer = setTimeout(function () {

		document.body.classList.add('menu-open');
		document.body.classList.add('mega-menu-open');
		document.body.classList.add('mega-menu-open--' + menuToOpen.slice(1));
		document.body.setAttribute("data-lenis-prevent", "true");

		menuItemActive.classList.add('active');
		menuItemActive.setAttribute('aria-expanded', 'true');

		document.querySelector(menuToOpen).classList.add('mega-menu--active');

	}, megaMenuDelay);
}


/**
 * Close the menu
 */
function closeMegaMenu() {
	clearTimeout(megaMenuTimer);

	// close .mega-menu after megaMenuDelay
	megaMenuTimer = setTimeout(function () {

		document.body.classList.remove('menu-open');

		// remove all the classes that start "mega-menu-open" with from body
		[...document.body.classList]
			.filter(cls => cls.startsWith("mega-menu-open"))
			.forEach(cls => document.body.classList.remove(cls));

		document.body.removeAttribute("data-lenis-prevent");

		document.querySelectorAll('.mega-menu--active').forEach(function (el) {
			el.classList.remove('mega-menu--active');
		});

		toggleMegaMenuItems.forEach(function (el) {
			el.classList.remove('active');
			el.setAttribute('aria-expanded', 'false');
		});

	}, megaMenuDelay);
}


/**
 * Add menu-open class to body when the user hovers a menu item
 */
document.querySelectorAll('.menu-item-has-children:not([data-mega-menu])').forEach(function (el) {
	['mouseenter', 'focus'].forEach(function (event) {
		el.addEventListener(event, function () {
			clearTimeout(megaMenuTimer);

			if (breakpointXl.matches)
			{
				closeMegaMenu();
			}

			// after hovering for megaMenuDelay, open the menu
			megaMenuTimer = setTimeout(function () {

				document.body.classList.add('menu-open');

			}, megaMenuDelay);
		});
	});

	['mouseleave', 'blur'].forEach(function (event) {
		el.addEventListener(event, function () {
			clearTimeout(megaMenuTimer);

			// close .mega-menu after megaMenuDelay
			megaMenuTimer = setTimeout(function () {

				if (breakpointXl.matches)
				{
					document.body.classList.remove('menu-open');
				}

			}, megaMenuDelay);

		});
	});
});

/**
 * KEYBOARD FLOW: trigger → mega menu → next trigger
 */
window.addEventListener('adaptNavigationToDesktop', function () {

	const focusableSelector = 'a, button, input, [tabindex]:not([tabindex="-1"])';

	const triggers = document.querySelectorAll('[data-mega-menu] > a, [data-mega-menu] > button');

	triggers.forEach((trigger, index) => {

		const parent = trigger.parentElement;
		const menuId = parent.dataset.megaMenu;

		if (!menuId)
		{
			return;
		}

		const menu = document.getElementById(menuId);

		if (!menu)
		{
			return;
		}

		/**
		 * #2 → TAB from trigger goes INTO mega menu
		 */
		trigger.addEventListener('keydown', (e) => {

			if (!breakpointXl.matches)
			{
				return;
			}

			if (e.key === 'Tab' && !e.shiftKey)
			{

				const items = menu.querySelectorAll(focusableSelector);
				if (!items.length)
				{
					return;
				}

				e.preventDefault();
				items[0].focus();
			}
		});

		/**
		 * #3 → TAB from last item goes to NEXT top-level item
		 */
		menu.addEventListener('keydown', (e) => {

			if (!breakpointXl.matches)
			{
				return;
			}

			if (e.key !== 'Tab')
			{
				return;
			}

			const items = menu.querySelectorAll(focusableSelector);

			if (!items.length)
			{
				return;
			}

			const first = items[0];
			const last  = items[items.length - 1];

			// SHIFT + TAB on first → previous focusable
			if (e.shiftKey && document.activeElement === first) {

				e.preventDefault();

				const prev = getPreviousFocusable(parent.querySelector(':scope > a'));

				if (prev) {
					prev.focus();
					closeMegaMenu();
				}
			}

			// TAB on last → go to next real focusable element
			if (!e.shiftKey && document.activeElement === last) {

				e.preventDefault();

				const next = getNextFocusable(parent.querySelector(':scope > a'));

				if (next) {
					next.focus();
					closeMegaMenu();
				}
			}
		});

	});

});


/**
 * Get all focusable elements in DOM order
 */
function getFocusableElements() {

	return Array.from(document.querySelectorAll(
		'a[href]:not([tabindex="-1"]):not([inert]), ' +
		'button:not([disabled]):not([tabindex="-1"]), ' +
		'input:not([disabled]):not([tabindex="-1"]), ' +
		'select:not([disabled]):not([tabindex="-1"]), ' +
		'textarea:not([disabled]):not([tabindex="-1"]), ' +
		'[tabindex]:not([tabindex="-1"])'
	)).filter(el => {
		return el.offsetParent !== null; // visible only
	});
}

function getNextFocusable(current) {

	const focusables = getFocusableElements();
	const index = focusables.indexOf(current);

	return focusables[index + 1] || null;
}

function getPreviousFocusable(current) {

	const focusables = getFocusableElements();
	const index = focusables.indexOf(current);

	return focusables[index - 1] || null;
}